<template>
    <div>
        <h3 class="title is-5">Personal information</h3>

        <backend-errors :data="update.error"/>

        <base-message v-if="update.succeed">
            Your account was successfully updated
        </base-message>

        <base-input label="Email" :value="user.email" icon="fas fa-envelope" disabled="true"/>

        <base-input
            label="First Name"
            v-model="form.first_name"
            name="first_name"
            icon="fas fa-user"
            validate="required"
            placeholder="First name"/>

        <base-input
            label="Last Name"
            v-model="form.last_name"
            name="last_name"
            icon="fas fa-user"
            validate="required"
            placeholder="Last name"/>

        <base-input
            label="Organization"
            v-model="form.company"
            name="company"
            icon="fas fa-building"
            validate="required"
            placeholder="Organization"/><br/>

        <base-button
            @click="send"
            :loading="update.loading"
            class="is-primary"
            icon="fas fa-check"
            text="Save"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import BackendErrors from '../base/BackendErrors.vue';
import { copy } from '../../utils/helpers';

export default {
    name: 'UserUpdateForm',
    components: { BackendErrors },
    data() {
        const data = copy(this.$store.state.user.user);

        return {
            form: {
                first_name: data.first_name,
                last_name: data.last_name,
                company: data.company,
            },
        };
    },
    computed: mapState('user', ['update', 'user']),
    destroyed() {
        this.$store.commit('user/clean_update');
    },
    methods: {
        send() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$store.dispatch('user/update', this.form);
            });
        },
    },
};
</script>
